import { useState } from 'react';
import { P2GGrid } from '@parcel2go/core-ui';
import { P2GText } from '@parcel2go/core-ui';
import { ClickableComponent } from './ClickableComponent';

interface props {
  confirmText?: string;
  confirm: () => void;
  initial?: boolean;
  children?: React.ReactNode;
  variant?: 'body2';
  component?: 'link' | 'button';
  fullWidth?: boolean;
}
const DropConfirm: React.FC<props> = (props) => {
  const [confirm, setConfirm] = useState(!!props.initial);
  return confirm ? (
    <P2GGrid wrap="nowrap" container gap={1} alignItems="center">
      <P2GGrid flexGrow={1} item>
        <P2GText variant={props.variant}>{props.confirmText || 'Are you sure?'}</P2GText>
      </P2GGrid>
      <P2GGrid flexShrink={1} item>
        <ClickableComponent linkVariant={props.variant} component={props.component} onClick={props.confirm}>
          Yes
        </ClickableComponent>
      </P2GGrid>
      <P2GGrid flexShrink={1} item>
        <ClickableComponent linkVariant={props.variant} component={props.component} onClick={() => setConfirm(false)}>
          No
        </ClickableComponent>
      </P2GGrid>
    </P2GGrid>
  ) : (
    <ClickableComponent
      fullWidth={props.fullWidth}
      linkVariant={props.variant}
      component={props.component}
      onClick={() => setConfirm(true)}
    >
      {props.children}
    </ClickableComponent>
  );
};

export default DropConfirm;
